import { createSlice } from '@reduxjs/toolkit';

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    contactActionSettings: null,
  },
  reducers: {
    setContactActionSettings(state, action) {
      state.contactActionSettings = action.payload;
    },
  },
});

export const { setContactActionSettings } = globalSlice.actions;

export default globalSlice.reducer;
